import React from "react";
import Button from "@ui/Button";
import { ZoomOutLine } from "@ui/IconV2/react";

interface PeriodZoomAllButtonProps {
  visible: boolean;
  onClick: () => void;
  label: string;
  className?: string;
}

const PeriodZoomAllButton = ({ visible, onClick, label, className }: PeriodZoomAllButtonProps) => {
  if (!visible) return null;

  return (
    <Button variant="tertiary" onClick={onClick} leftIcon={<ZoomOutLine />} className={className}>
      {label}
    </Button>
  );
};

export default React.memo(PeriodZoomAllButton);
